import {i18n} from '@lingui/core';
import {t} from '@lingui/macro';

import {ServerAuthenticationStrategiesEnum, ServerSendAsTargetsEnum} from './serverModel';

export function getServerAuthenticationStrategyLabel(strategy: ServerAuthenticationStrategiesEnum) {
  return serverAuthenticationStrategyLabels[strategy];
}

const serverAuthenticationStrategyLabels: Record<ServerAuthenticationStrategiesEnum, string> = {
  [ServerAuthenticationStrategiesEnum.NONE]: i18n._(t('server-authentication-strategy-none')`None`),
  [ServerAuthenticationStrategiesEnum.BASIC]: i18n._(t('server-authentication-strategy-basic')`Basic`),
  [ServerAuthenticationStrategiesEnum.BEARER]: i18n._(t('server-authentication-strategy-bearer')`Bearer`),
  [ServerAuthenticationStrategiesEnum.OAUTH2]: i18n._(t('server-authentication-strategy-oauth2')`OAuth 2`),
};

export function getServerSendAsTargetLabel(target: ServerSendAsTargetsEnum) {
  return serverSendAsTargetLabels[target];
}

const serverSendAsTargetLabels: Record<ServerSendAsTargetsEnum, string> = {
  [ServerSendAsTargetsEnum.HEADER]: i18n._(t('server-send-as-header-target')`Header`),
  [ServerSendAsTargetsEnum.QUERY_PARAM]: i18n._(t('server-send-as-query-param-target')`Query param`),
};
